class RequestMonitorService {
  constructor(client) {
    this.apiClient = client;
  }

  async getRequestedTickets(entityId, cancelToken) {
    return this.apiClient.get(`requestmonitor/${entityId}`,cancelToken);
  }

  async closeRequestMonitorPopUp() {
    return await this.apiClient.post(`valetrequestmonitor/closerequestmonitor`);
  }

  async getAverageWaitTime(entityIDs) {
    return await this.apiClient.post("requestmonitor/averagewaittime", entityIDs);
  }

  async getValetEmployees(request) {
    return await this.apiClient.post(`requestmonitor/getvaletemployees`, request);
  }
}

export default RequestMonitorService;
